import React, { } from "react";
import { Card, Container, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Attendant from './../../assets/attendant.svg';
import Management from './../../assets/management.svg';
import Support from './../../assets/support.svg';
import styles from './style.module.css';

function Assurance(props) {
    return (
        <>
            <div className={styles.main} style={{ backgroundColor: "#eeeeee" }}>
                <div className="offset-lg-1 col-lg-10">
                    <div style={{ fontSize: "25px", fontWeight: "bold" }} className="text-center pt-3 mb-2">Care24 Assurance</div>
                    <div className="container">
                        <Row className={styles.subMain}>
                            <div className={"col-lg-4 col-md-12 col-sm-12 mt-2"}>
                                <Card className="p-2" style={{ border: "none", backgroundColor: "#eeeeee" }}>
                                    <Row>
                                        <div className="align-self-center align-self-baseline col-2 col-lg-12 col-md-2 col-sm-2 pb-2" >
                                            <div className="text-center">
                                                <img src={Attendant} alt="React Logo" className={styles.icon} />
                                            </div>
                                        </div>
                                        <Card.Body className="pt-0 pb-0 col-10 col-lg-12 col-md-10 col-sm-10">
                                            <h2 style={{
                                                fontSize: 16,
                                                fontWeight: 600
                                            }} className=" mb-3">
                                                Trained and Verified Attendants
                                            </h2>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                }}>Background verification</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Recognized Onboarding & Training Programs</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Frequent on-the-job training</div>
                                            </Row>
                                        </Card.Body>
                                    </Row>
                                </Card>
                            </div>
                            <div className={"col-lg-4 col-md-12 col-sm-12  mt-2"}>
                                <Card className="p-2" style={{ border: "none", backgroundColor: "#eeeeee" }}>
                                    <Row>
                                        <div className="align-self-center align-self-baseline col-2 col-lg-12 col-md-2 col-sm-2 pb-2">
                                            <div className="text-center" >
                                                <img src={Management} alt="React Logo" className={styles.icon} />
                                            </div>
                                        </div>
                                        <Card.Body className="pt-0 pb-0 col-10 col-lg-12 col-md-10 col-sm-10">
                                            <h2 style={{
                                                fontSize: 16,
                                                fontWeight: 600
                                            }} className="mb-3">
                                                Coordinated Care and Management
                                            </h2>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Physician Directed Care Plans</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Managed By Licensed Nurses</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Complete Care Portfolio</div>
                                            </Row>
                                        </Card.Body>
                                    </Row>
                                </Card>
                            </div>
                            <div className={"col-lg-4 col-md-12 col-sm-12 mt-2"}>
                                <Card className="p-2" style={{ border: "none", backgroundColor: "#eeeeee" }}>
                                    <Row>
                                        <div className="align-self-center align-self-baseline col-2 col-lg-12 col-md-2 col-sm-2 pb-2">
                                            <div className="text-center" >
                                                <img src={Support} alt="React Logo" className={styles.icon} />
                                            </div>
                                        </div>
                                        <Card.Body className="pt-0 pb-0 col-10 col-lg-12 col-md-10 col-sm-10">
                                            <h2 style={{
                                                fontSize: 16,
                                                fontWeight: 600
                                            }} className="mb-3">
                                                All-round medical support
                                            </h2>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>24/7 customer support</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Mobile app to manage services</div>
                                            </Row>
                                            <Row>
                                                <div className="col-1">
                                                    <FontAwesomeIcon icon="check" />
                                                </div>
                                                <div className="col-10" style={{
                                                    fontSize: 14,
                                                    fontWeight: 400
                                                }}>Easy leave replacements for continued care</div>
                                            </Row>
                                        </Card.Body>
                                    </Row>
                                </Card>
                            </div>
                        </Row>
                    </div>
                </div >
            </div>
        </>
    );
}

export default Assurance